import { type FC, type ReactNode } from "react";
import { Navigate, Outlet } from "react-router-dom";

import { useFeatureGates } from "../../cof-feature-gates/hooks";
import { type CofConfigId } from "../../gql-generated/types";
import { PageContentSpinner } from "../../layout/components/PageContentSpinner";

import { AbsoluteRoute } from "./absoluteRoutes";

interface GatedRouteProps {
    gateKey: CofConfigId;
    fallbackPath?: string;
    children?: ReactNode;
}

export const GatedRoute: FC<GatedRouteProps> = ({ gateKey, fallbackPath, children }) => {
    const { loading, configs } = useFeatureGates();

    // Wait for the COF query to settle before deciding. Without this, the gate
    // sees boolValue: false during loading and redirects to ROOT — kicking
    // embed users out of /embed/* into the main app's AuthGuard flow.
    if (loading) return <PageContentSpinner />;

    const isGateEnabled = configs[gateKey].enabled;
    return isGateEnabled ? children ?? <Outlet /> : <Navigate to={fallbackPath ?? AbsoluteRoute.ROOT} />;
};
